"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const DropdownItem = ({ title, disabled, onClick, icon: Icon }) => {
    if (!title || title === 'SPACER')
        return react_1.default.createElement("div", { className: "border-t border-gray-100" });
    return (react_1.default.createElement("div", { className: `py-1 ${disabled
            ? ''
            : 'hover:bg-gray-100 dark:hover:bg-gray-800 focus:outline-none dark-hover:bg-gray-800'}` },
        react_1.default.createElement("button", { disabled: disabled, onClick: () => {
                if (onClick)
                    onClick();
            }, className: `group flex w-full items-center px-4 py-2 text-sm leading-5 ${disabled
                ? 'text-gray-300 dark:text-gray-800'
                : 'text-gray-700 dark:text-gray-300 hover:text-gray-900 dark-hover:text-white '}`, role: "menuitem" },
            Icon && (react_1.default.createElement(Icon, { className: `mr-3 h-5 w-5  ${disabled
                    ? 'text-gray-300 dark:text-gray-800'
                    : 'text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 '}` })),
            title)));
};
exports.default = DropdownItem;
